import { Link, useHistory, useLocation } from 'react-router-dom';
import * as React from 'react';
import { ClickTracker } from 'bernie-plugin-analytics';
import { mergeQueryString } from 'bernie-core';
/* eslint-disable max-len */
import { useLocalization } from '@shared-ui/localization-context';
import { UitkCardContentSection } from 'uitk-react-cards';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkPriceLockup } from 'uitk-react-price-lockup';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { TextTheme } from '../../../../../../constants';
import { mapDisclaimerToMessageContent } from '../../../../../../utils/disclaimer';
import { useStores } from '../../../../../../utils/hooks';
import { objectArrayToArrayConversion } from '../../../../../../helpers/popup-message-array-helper';
import { ActivityFeature } from '../components/activity-feature';
import { ActivitySpannedTileCardTitle } from './activity-spanned-tile-card-title';
import { getPriceDetails } from '../../../../../../business';
import { ImageBadges } from '../../image-badges';
import { MessageAnchor } from '../../../../../common/message-anchor';
import { PopupMessage } from '../../../../../common/popup-message';
export var ActivitySpannedTileCardContent = function (_a) {
  var _b, _c, _d, _e, _f, _g;
  var activity = _a.activity,
    activityGroup = _a.activityGroup,
    isVerticalLayout = _a.isVerticalLayout,
    isInCarousel = _a.isInCarousel,
    titleLines = _a.titleLines;
  var secondaryBadge = (_b = activity.cardBadges) === null || _b === void 0 ? void 0 : _b.secondary;
  var freeCancellationFeature = activity.features.freeCancellationFeature;
  var activityDuration = activity.activityDuration;
  var formatText = useLocalization().formatText;
  var LinkTracked = ClickTracker(Link);
  var linkRef = React.useRef();
  var analytics = useStores().analytics;
  var history = useHistory();
  var location = useLocation();
  var _h = getPriceDetails(activity),
    strikeThroughPrice = _h.strikeThroughPrice,
    lockupPrice = _h.lockupPrice,
    lockupFormattedPoints = _h.lockupFormattedPoints,
    priceSubtextFirst = _h.priceSubtextFirst,
    accessibilityPrice = _h.accessibilityPrice,
    priceDisclaimer = _h.priceDisclaimer,
    leadingCaption = _h.leadingCaption,
    isPointsFirstDisplay = _h.isPointsFirstDisplay,
    isStrikeThroughFirstDisplay = _h.isStrikeThroughFirstDisplay;
  var hotelPickup = activity.features.hotelPickup;
  var reviewsMessageDisclaimer = (_c = activity.reviewSummary) === null || _c === void 0 ? void 0 : _c.disclaimer;
  var priceDisclaimerId = activityGroup ? "legal-price-disclaimer-".concat(activity.id, "-").concat(activityGroup) : "legal-price-disclaimer-".concat(activity.id);
  var activityReviewId = activityGroup ? "review-legal-disclaimer-dialog-".concat(activity.id, "-").concat(activityGroup) : "review-legal-disclaimer-dialog-".concat(activity.id);
  var disclaimer = reviewsMessageDisclaimer || priceDisclaimer;
  var _j = mapDisclaimerToMessageContent(disclaimer),
    icon = _j.icon,
    content = _j.content,
    disclaimerDialog = _j.disclaimerDialog,
    triggerAnalytics = _j.triggerAnalytics,
    accessibility = _j.accessibility;
  return React.createElement(UitkLayoutGridItem, {
    colSpan: {
      medium: isVerticalLayout ? 1 : 2
    }
  }, React.createElement(UitkCardContentSection, null, React.createElement(UitkLayoutFlex, {
    tag: "section",
    direction: "column",
    className: "uitk-card-text-segment full-width max-height",
    alignContent: "space-between"
  }, isVerticalLayout ? null : React.createElement(UitkLayoutFlexItem, null, React.createElement(ActivitySpannedTileCardTitle, {
    activity: activity,
    isInCarousel: isInCarousel,
    isVerticalLayout: isVerticalLayout,
    titleLines: titleLines
  })), React.createElement(UitkLayoutFlexItem, {
    grow: 1
  }, React.createElement(UitkLayoutFlex, {
    wrap: "nowrap",
    tag: "section",
    direction: "row",
    "data-testid": "activity-spanned-tile-card-content",
    justifyContent: "space-between",
    className: "max-height"
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkLayoutFlex, {
    wrap: "nowrap",
    tag: "section",
    direction: "column",
    justifyContent: "space-between"
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkLayoutFlex, {
    wrap: "nowrap",
    tag: "section",
    direction: "column",
    justifyContent: "start"
  }, (activityDuration === null || activityDuration === void 0 ? void 0 : activityDuration.text) && React.createElement(UitkSpacing, {
    margin: {
      blockend: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, {
    className: "uitk-type-200"
  }, React.createElement(ActivityFeature, {
    label: activityDuration.text,
    a11yLabel: formatText('lx.search.activity.duration', activityDuration.text),
    icon: activityDuration.icon,
    "data-testid": "activity-duration--feature"
  }))), ((_d = activity.reviewSummary) === null || _d === void 0 ? void 0 : _d.reviewRatingMessage) && React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkLayoutFlex, {
    alignItems: "center",
    "data-testid": "activity-review-rating"
  }, React.createElement(UitkSpacing, {
    margin: {
      inlineend: 'one'
    }
  }, React.createElement(UitkText, {
    size: 300,
    weight: "bold",
    theme: "emphasis"
  }, activity.reviewSummary.reviewRatingMessage)), React.createElement(UitkText, {
    size: 300,
    theme: "default"
  }, activity.reviewSummary.reviewCountMessage), reviewsMessageDisclaimer && React.createElement(MessageAnchor, {
    dialogId: activityReviewId,
    text: "",
    id: "review-info-".concat(activity.id),
    icon: icon,
    dismissAction: disclaimerDialog,
    disclaimer: disclaimer,
    messages: objectArrayToArrayConversion(content),
    triggerAnalytics: triggerAnalytics,
    anchorClasses: "uitk-type-300 type-gray",
    analytics: analytics,
    isNestedPopup: true,
    buttonType: "Link"
  }))), ((_e = activity.features.travelDistance) === null || _e === void 0 ? void 0 : _e.label) && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'two'
    }
  }, React.createElement(UitkLayoutFlexItem, {
    className: "uitk-type-200"
  }, React.createElement(ActivityFeature, {
    label: activity.features.travelDistance.label,
    "data-testid": "activity-travel-distance--feature"
  }))), hotelPickup && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'two'
    }
  }, React.createElement(UitkLayoutFlexItem, {
    className: "uitk-type-200"
  }, React.createElement(ActivityFeature, {
    label: hotelPickup.label,
    icon: hotelPickup.icon_temp,
    "data-testid": "activity-hotel-pickup--feature"
  }))))), (freeCancellationFeature || activity.features.loyaltyEarnAwards) && React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'three'
    }
  }, React.createElement(UitkLayoutFlex, {
    wrap: "nowrap",
    tag: "section",
    direction: "column",
    justifyContent: "end"
  }, freeCancellationFeature && React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkText, {
    size: 200,
    theme: freeCancellationFeature.theme ? TextTheme[freeCancellationFeature.theme] : 'positive',
    "data-testid": "activity-free-cancellation"
  }, freeCancellationFeature.text)), activity.features.loyaltyEarnAwards && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, {
    className: "uitk-type-300 color-accent-3"
  }, React.createElement(ActivityFeature, {
    label: activity.features.loyaltyEarnAwards.label,
    mark: activity.features.loyaltyEarnAwards.mark,
    isLoyaltyEarnDisplay: true,
    "data-testid": "loyalty-earn-award--feature"
  })))))))), React.createElement(UitkLayoutFlexItem, {
    maxWidth: "half_width"
  }, React.createElement(UitkLayoutFlex, {
    wrap: "nowrap",
    tag: "section",
    direction: "column",
    justifyContent: "end"
  }, !isVerticalLayout && secondaryBadge && React.createElement(UitkLayoutFlexItem, {
    alignSelf: "end"
  }, React.createElement(UitkSpacing, {
    margin: {
      blockend: 'one'
    }
  }, React.createElement("div", {
    "data-testid": "activity-badge"
  }, React.createElement(ImageBadges, {
    badges: {
      secondary: secondaryBadge,
      __typename: 'ActivityCardBadges'
    },
    isVerticalLayout: false
  })))), React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkLayoutPosition, {
    position: {
      zindex: 'layer2'
    }
  }, React.createElement(UitkPriceLockup, {
    lockupFormattedPoints: lockupFormattedPoints || undefined,
    a11yPrice: accessibilityPrice || '',
    lockupPrice: lockupPrice || undefined,
    priceSubtextFirst: priceSubtextFirst || undefined,
    strikeThroughPrice: strikeThroughPrice || undefined,
    a11yStrikeThroughDialogTrigger: priceDisclaimer ? accessibility : undefined,
    leadingCaption: leadingCaption || undefined,
    isPointsFirst: isPointsFirstDisplay,
    isStrikeThroughFirst: isStrikeThroughFirstDisplay,
    strikeThroughTrigger: React.createElement(LinkTracked, {
      to: {
        pathname: location.pathname,
        search: mergeQueryString(history.location.search, {
          pwaDialogNested: priceDisclaimerId
        })
      },
      rfrr: "",
      linkName: ""
    })
  }), priceDisclaimer && React.createElement(PopupMessage, {
    dialogId: priceDisclaimerId,
    dismissAction: disclaimerDialog,
    disclaimer: disclaimer,
    analytics: analytics,
    isNestedPopup: true,
    messages: objectArrayToArrayConversion(content),
    linkRef: linkRef
  }))), ((_f = activity.leadTicketPrice.priceLockup) === null || _f === void 0 ? void 0 : _f.priceSubtextStandard) && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkText, {
    size: 200,
    align: "right",
    "data-testid": "activity-taxes-and-fees-message"
  }, activity.leadTicketPrice.priceLockup.priceSubtextStandard.map(function (message, count) {
    return React.createElement(UitkText, {
      key: count
    }, message);
  })))), ((_g = activity.features.volumePricing) === null || _g === void 0 ? void 0 : _g.description) && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkText, {
    size: 100,
    align: "right",
    "data-testid": "activity-volume-based-pricing"
  }, activity.features.volumePricing.description))))))))));
};